import { Button, PreloaderCircular } from '@shared/ui/kit';
import styles from './organizer-sending.module.scss';

interface OrganizerSendingProps {
  onClose: () => void;
}

export const OrganizerSending = ({ onClose }: OrganizerSendingProps) => {
  return (
    <>
      <div className={styles.sending}>
        <PreloaderCircular variant="accent" size="l" />

        <p className={styles.sendingText}>Процесс может занять некоторое время</p>
      </div>

      <div className={styles.sendingActions}>
        <Button
          size="small"
          variant="accent"
          settings={{ padding: 'var(--space-8) var(--space-20)', fontSize: 'var(--font-size-caption-1)' }}
          onClick={onClose}
        >
          Закрыть
        </Button>
      </div>
    </>
  );
};
